import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/site";

export const FloatingWhatsapp = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          data-testid="floating-whatsapp"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          whileHover={{ scale: 1.1 }}
          className="fixed bottom-5 right-5 z-[60] flex items-center gap-2 bg-[#25D366] text-black font-bold uppercase tracking-wide px-4 py-4 rounded-full wa-glow"
        >
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
          <MessageCircle size={26} className="relative" />
          <span className="relative hidden sm:inline text-sm">WhatsApp</span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};
